import { render, staticRenderFns } from "./JirikTeplota.vue?vue&type=template&id=c2a6ff5c&scoped=true&"
import script from "./JirikTeplota.vue?vue&type=script&lang=js&"
export * from "./JirikTeplota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a6ff5c",
  null
  
)

export default component.exports